import { LIST_ACTIONS } from 'lib/list-helper/makeListReducer';
import useQueryList from 'lib/list-helper/useQueryList';
import { reducer, initialState } from './inspectionTypesListReducer';
import inspectionTypesService from './inspectionTypesService';
import debounce from 'lodash.debounce';

const fetchInspectionTypes = debounce((params, _, dispatch) => {
  dispatch({ type: LIST_ACTIONS.SET_LOADING, payload: true });

  return inspectionTypesService
    .getInspectionTypes(params)
    .then((results) => {
      dispatch({
        type: LIST_ACTIONS.APP_LOADS_DATA,
        payload: { ...results },
      });
      return results;
    })
    .catch((e) => {
      dispatch({
        type: LIST_ACTIONS.SHOW_ERROR,
        payload: e.message,
      });
    })
    .then(() => {
      dispatch({ type: LIST_ACTIONS.SET_LOADING, payload: false });
    });
}, 400);

const useInspectionTypesList = ({ location, history }) => {
  const list = useQueryList(
    location,
    history,
    reducer,
    initialState,
    fetchInspectionTypes,
  );

  const userClicksOnRow = (id) => {
    history.push(`/inspection-types/${id}`);
  };

  return { ...list, userClicksOnRow };
};

export default useInspectionTypesList;
